import { createIcon } from '@chakra-ui/icons';

export const Conference = createIcon({
  displayName: 'Conference',
  viewBox: '0 0 16 16',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_168_4261)">
        <path
          d="M11.982 2.46066C11.5002 1.91673 10.9121 1.47718 10.254 1.16906C9.59594 0.860937 8.88176 0.690772 8.15544 0.669039C7.42913 0.647306 6.70605 0.774463 6.03072 1.04268C5.3554 1.3109 4.74212 1.71451 4.22864 2.22866"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M9.98529 4.23532C9.74576 3.96239 9.45269 3.74161 9.12428 3.58667C8.79586 3.43173 8.43911 3.34595 8.07616 3.33463C7.7132 3.32332 7.3518 3.38672 7.01437 3.5209C6.67694 3.65508 6.37069 3.85718 6.11462 4.11465"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M0.666626 4C1.72749 4 2.74491 4.42143 3.49505 5.17157C4.2452 5.92172 4.66663 6.93913 4.66663 8V8.69333L5.66663 11L4.66663 11.3333V12.6667C4.66663 13.0203 4.52615 13.3594 4.2761 13.6095C4.02605 13.8595 3.68691 14 3.33329 14H1.99996V15.3333"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M15.3334 4C14.2725 4 13.2551 4.42143 12.5049 5.17157C11.7548 5.92172 11.3334 6.93913 11.3334 8V8.69333L10.3334 11L11.3334 11.3333V12.6667C11.3334 13.0203 11.4739 13.3594 11.7239 13.6095C11.9739 13.8595 12.3131 14 12.6667 14H14V15.3333"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_168_4261">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
